import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import axios from 'axios'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import { debounceAction } from '@Infowijs-eng/component-library/modules/authentication'
import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import actionTypes from '../../action-types'
import fetchAdministrator from '../../actions/administrators/fetchAdministrator'
import setAdministrator from '../../actions/administrators/setAdministrator'
import awaitAccessToken from '../../modules/awaitAccessToken'

const onFetchAdministrator = function* onFetchAdministrator() {
  yield takeLatest(actionTypes.ADMINISTRATORS.FETCH, function* onFetchAdministratorSaga(action) {
    const accessToken = yield call(awaitAccessToken)

    let response
    const { payload: { id } } = action

    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.administrators}/${id}`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
          'X-Infowijs-Client': 'nl.infowijs.admin',
        },
      })
    } catch (e) {
      if (e.response.status === 401) {
        yield debounceAction(function* reFetchAdministrators() {
          yield put(fetchAdministrator(id))
        })
      }

      rejectAction(action, e.response.data && e.response.data.errors)
      return
    }

    yield put(setAdministrator(response.data.data))

    acceptAction(action, response.data.data)
  })
}

export default onFetchAdministrator
